// File: CopyIcon.jsx

function CopyIcon({ width = 20, height = 20, fill = "#F9EFDD" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_45_1048)">
        <path d="M13.3332 0.833374H3.33317C2.4165 0.833374 1.6665 1.58337 1.6665 2.50004V14.1667H3.33317V2.50004H13.3332V0.833374ZM15.8332 4.16671H6.6665C5.74984 4.16671 4.99984 4.91671 4.99984 5.83337V17.5C4.99984 18.4167 5.74984 19.1667 6.6665 19.1667H15.8332C16.7498 19.1667 17.4998 18.4167 17.4998 17.5V5.83337C17.4998 4.91671 16.7498 4.16671 15.8332 4.16671ZM15.8332 17.5H6.6665V5.83337H15.8332V17.5Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_45_1048">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CopyIcon;
